import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import { ParallaxProvider } from 'react-scroll-parallax'
import { theme, globalStyles } from 'config/theme'
import Layer from 'components/atoms/Layer'
import gothamFont from 'assets/fonts/gotham'

const GlobalStyles = createGlobalStyle`
  ${globalStyles}
`

const App = ({ children }) => {
  return (
    <ParallaxProvider>
      <ThemeProvider theme={theme}>
        <React.Fragment>
          <Helmet>
            <style>{gothamFont}</style>
          </Helmet>
          <GlobalStyles />
          <Layer>{children}</Layer>
        </React.Fragment>
      </ThemeProvider>
    </ParallaxProvider>
  )
}

App.propTypes = {
  children: PropTypes.node.isRequired,
}

export default App
